/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
export function arrayLess(arr, i, j) {
  return arr[i] - arr[j];
}
export function arraySwap(arr, i, j) {
  var temp = arr[i];
  arr[i] = arr[j];
  arr[j] = temp;
}

function medianPivotIndex(data, cmp, l, r) {
  var m = l + r >> 1;
  if (cmp(data, l, r) > 0) return cmp(data, l, m) > 0 ? cmp(data, m, r) > 0 ? m : r : l;else return cmp(data, r, m) > 0 ? cmp(data, m, l) > 0 ? m : l : r;
}

function partition(ctx, l, r) {
  var cmp = ctx.cmp,
      swap = ctx.swap,
      data = ctx.data,
      parts = ctx.parts;
  var equals = l + 1,
      tail = r; // move the median to the 1st spot

  swap(data, l, medianPivotIndex(data, cmp, l, r));

  while (cmp(data, tail, l) > 0) {
    --tail;
  }

  for (var i = l + 1; i <= tail; i++) {
    var c = cmp(data, i, l);

    if (c > 0) {
      swap(data, i, tail);
      --tail;

      while (cmp(data, tail, l) > 0) {
        --tail;
      }

      i--;
    } else if (c === 0) {
      swap(data, i, equals);
      equals++;
    }
  } // move the medians to the correct spots


  for (var i = l; i < equals; i++) {
    swap(data, i, l + tail - i);
  }

  parts[0] = tail - equals + l + 1;
  parts[1] = tail;
}

function insertionSort(_a, start, end) {
  var data = _a.data,
      cmp = _a.cmp,
      swap = _a.swap;

  for (var i = start + 1; i <= end; i++) {
    var j = i - 1;

    while (j >= start && cmp(data, j, j + 1) > 0) {
      swap(data, j, j + 1);
      j = j - 1;
    }
  }
}

function quickSort(ctx, low, high) {
  var parts = ctx.parts;

  while (low < high) {
    if (high - low < 16) {
      insertionSort(ctx, low, high);
      return;
    }

    partition(ctx, low, high);
    var li = parts[0],
        ri = parts[1];

    if (li - low < high - ri) {
      quickSort(ctx, low, li - 1);
      low = ri + 1;
    } else {
      quickSort(ctx, ri + 1, high);
      high = li - 1;
    }
  }
}

function partitionArrayAsc(data, parts, l, r) {
  var equals = l + 1,
      tail = r; // move the median to the 1st spot

  arraySwap(data, l, medianPivotIndex(data, arrayLess, l, r));
  var pivot = data[l];

  while (data[tail] > pivot) {
    --tail;
  }

  for (var i = l + 1; i <= tail; i++) {
    var v = data[i];

    if (v > pivot) {
      arraySwap(data, i, tail);
      --tail;

      while (data[tail] > pivot) {
        --tail;
      }

      i--;
    } else if (v === pivot) {
      arraySwap(data, i, equals);
      ++equals;
    }
  } // move all medians to the correct spots


  for (var i = l; i < equals; i++) {
    arraySwap(data, i, l + tail - i);
  }

  parts[0] = tail - equals + l + 1;
  parts[1] = tail;
}

function insertionSortArrayAsc(data, start, end) {
  for (var i = start + 1; i <= end; i++) {
    var key = data[i];
    var j = i - 1;

    while (j >= start && data[j] > key) {
      data[j + 1] = data[j];
      j = j - 1;
    }

    data[j + 1] = key;
  }
}

function quickSortArrayAsc(data, parts, low, high) {
  while (low < high) {
    if (high - low < 16) {
      insertionSortArrayAsc(data, low, high);
      return;
    }

    partitionArrayAsc(data, parts, low, high);
    var li = parts[0],
        ri = parts[1];

    if (li - low < high - ri) {
      quickSortArrayAsc(data, parts, low, li - 1);
      low = ri + 1;
    } else {
      quickSortArrayAsc(data, parts, ri + 1, high);
      high = li - 1;
    }
  }
}

export function sortArray(data, cmp) {
  if (cmp === void 0) {
    cmp = arrayLess;
  }

  return sortArrayRange(data, 0, data.length, cmp);
}
export function sortArrayRange(data, start, end, cmp) {
  if (cmp === void 0) {
    cmp = arrayLess;
  }

  if (cmp === arrayLess) quickSortArrayAsc(data, [0, 0], start, end - 1);else quickSort({
    data: data,
    cmp: cmp,
    swap: arraySwap,
    parts: [0, 0]
  }, start, end - 1);
  return data;
}
export function sort(data, start, end, cmp, swap) {
  var ctx = {
    data: data,
    cmp: cmp,
    swap: swap,
    parts: [0, 0]
  };
  quickSort(ctx, start, end - 1);
  return data;
}